import { FormType, OrganizationType, ProductDonationRecurrenceInterval } from "../../enums";
import { OrganizationCountry } from "../enums/country";
export const DAF_MINIMUM_AMOUNT = 100_000;
export const countryAllowsDaf = (country) => country === OrganizationCountry.UnitedStates;
export const isDafEligibleOrganization = (organization) => countryAllowsDaf(organization.country) &&
    organization.type === OrganizationType.Charity &&
    Boolean(organization.charityNumber?.trim() &&
        organization.address?.trim() &&
        organization.city?.trim() &&
        organization.region?.trim() &&
        organization.postalCode?.trim());
export const isDafPaymentAvailable = ({ organization, formType, dafEnabled, amount, recurrenceInterval, }) => Boolean(dafEnabled) &&
    formType === FormType.DonationForm &&
    isDafEligibleOrganization(organization) &&
    recurrenceInterval === ProductDonationRecurrenceInterval.OneTime &&
    Number.isSafeInteger(amount) &&
    amount >= DAF_MINIMUM_AMOUNT;
